import { useSelector } from 'react-redux';
import {
  BILLING_METHOD_CAT_PREPAID_CERT,
  STATUS
} from '@app/constants/commonConstants';
import { prependCurrencySymbol } from './utils';

export const useCatCreditsTotals = ({
  catCreditTotal,
  orderRemainingPaymentAmount
}) => {
  const isCatCreditInternationalPhaseOne = useSelector(
    state => state.dealer?.isCreditsInternationalPhaseOneEnabled
  );

  const isCatCreditInternationalPhaseTwo = useSelector(
    state => state.dealer?.isCreditsInternationalPhaseTwoEnabled
  );

  const isCatCreditInternational =
    isCatCreditInternationalPhaseOne || isCatCreditInternationalPhaseTwo;

  const amountUsedCatCreditsGlobal = useSelector(
    s =>
      s.checkout?.applyCatCreditsGlobal?.applyCatCreditsGlobalBalance
        ?.amountUsedCatCreditsGlobal
  );

  const selectedBillingMethod = useSelector(
    s => s.checkout?.selectedBillingMethod
  );

  const certificates = useSelector(
    state => state.checkout?.prepaidCertificates?.certificates
  );

  const applyCatVantageRewardsToOrderStatus = useSelector(
    state => state.checkout?.applyCatVantageRewardsToOrderStatus
  );

  const showCatCreditTotal =
    selectedBillingMethod?.value === BILLING_METHOD_CAT_PREPAID_CERT &&
    certificates?.length > 0;
  const showCatCredit =
    (isCatCreditInternational && amountUsedCatCreditsGlobal) ||
    showCatCreditTotal ||
    applyCatVantageRewardsToOrderStatus === STATUS.RESOLVED;

  const applyCatCreditsGlobalBalance = useSelector(
    s => s.checkout?.applyCatCreditsGlobal?.applyCatCreditsGlobalBalance
  );

  const isDualCurrencySupportFlagEnabled = useSelector(
    state => state.featureFlag?.PCC_DualCurrencySupportFlag
  );

  const usedAmountSalesforceCurrency =
    applyCatCreditsGlobalBalance?.usedAmountForeignCurrency;

  const creditTotalsValue =
    isDualCurrencySupportFlagEnabled && usedAmountSalesforceCurrency
      ? prependCurrencySymbol(usedAmountSalesforceCurrency)
      : catCreditTotal;

  const amountUsedCatCreditsGlobalFixed = amountUsedCatCreditsGlobal
    ? parseFloat(amountUsedCatCreditsGlobal).toFixed(2)
    : null;

  const creditSubValue =
    isDualCurrencySupportFlagEnabled &&
    usedAmountSalesforceCurrency &&
    prependCurrencySymbol(amountUsedCatCreditsGlobalFixed);

  const remainingAmountSalesforceCurrency =
    applyCatCreditsGlobalBalance?.remainingAmountForeignCurrency;

  const useRemainingAmountSalesforceCurrency =
    showCatCredit &&
    isDualCurrencySupportFlagEnabled &&
    remainingAmountSalesforceCurrency;

  const remainingAmountNum = useRemainingAmountSalesforceCurrency
    ? remainingAmountSalesforceCurrency
    : orderRemainingPaymentAmount ?? 0;

  const remainingAmount = useRemainingAmountSalesforceCurrency
    ? prependCurrencySymbol(remainingAmountNum)
    : remainingAmountNum;

  const remainingAmountFixed =
    isDualCurrencySupportFlagEnabled && remainingAmount
      ? parseFloat(remainingAmountNum ?? '0').toFixed(2)
      : null;

  const remainingAmountSub =
    remainingAmountSalesforceCurrency &&
    isDualCurrencySupportFlagEnabled &&
    prependCurrencySymbol(remainingAmountFixed);

  const accountCurrencyCode = useSelector(
    s => s.checkout.catSalesForceAccountBalance?.accountCurrencyCode
  );

  return {
    showCatCredit,
    creditTotalsValue,
    creditSubValue,
    remainingAmount,
    remainingAmountSub,
    accountCurrencyCode
  };
};
